import React from 'react'

import FlexGrid from '../../structure/FlexGrid'
import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import { Grid } from '../../../packages/kiti/components/structure/Grid'
import Text from '../../../packages/kiti/components/presentation/Text'
import Circle from '../../../packages/kiti/components/shapes/Circle'
import Button from '../../../packages/kiti/components/actions/Button'
import { isEmpty } from 'lodash'

const WorkShiftsInputButton = ({ onClick }) => {
  const { form } = useFormState()
  const total = form.contract?.workShifts?.reduce((acc, item, index) => {
    if (item.length === 1 && isEmpty(item[0])) return acc
    return ++acc
  }, 0)
  return (
    <>
      <FlexGrid gutter={1.2} justify="left">
        <Button transparent onClick={onClick} badge={form.contract?.workShifts?.length}>
          <Grid gap={0.5}>
            <Text size={'small'} align="center" color={'primary'} bold>
              {'+ Configurar turnos de trabalho'}
            </Text>
            {!!form.contract?.workShifts?.length && (
              <Circle size={'20px'}>
                <Text color={'white'} size={'xsmall'}>
                  {total}
                </Text>
              </Circle>
            )}
          </Grid>
        </Button>
      </FlexGrid>
    </>
  )
}

export default WorkShiftsInputButton
